/* trash_bin.icon.svg.js */

"use strict";
module.exports = {
    icon: `
            <svg viewBox="0 0 13.9 16" preserveAspectRatio="none">
            <g>
                <path class="foreground-gl" d="M6.9,14c0.3,0,0.6-0.2,0.6-0.5V7.1c0-0.3-0.3-0.5-0.6-0.5S6.4,6.8,6.4,7.1v6.4C6.4,13.8,6.6,14,6.9,14z"/>
                <path class="foreground-gl" d="M9.2,14c0.3,0,0.6-0.2,0.6-0.5V7.1c0-0.3-0.3-0.5-0.6-0.5S8.7,6.8,8.7,7.1v6.4C8.7,13.8,8.9,14,9.2,14z"/>
                <path class="foreground-gl" d="M4.7,14c0.3,0,0.6-0.2,0.6-0.5V7.1c0-0.3-0.3-0.5-0.6-0.5c-0.3,0-0.6,0.2-0.6,0.5v6.4C4.1,13.8,4.3,14,4.7,14z
                    "/>
                <path class="foreground-gl" d="M13.9,4V2.9c0-0.3-0.2-0.5-0.5-0.5H9.8l-0.7-2C9,0.1,8.8,0,8.6,0H5.3C5.1,0,4.9,0.1,4.8,0.4L4,2.4H0.5
                    C0.2,2.4,0,2.6,0,2.9V4c0,0.3,0.2,0.5,0.5,0.5H0.1l1.1,9.7C1.2,15.2,2,16,2.9,16h8c0.9,0,1.7-0.8,1.7-1.7l1.1-9.7h-0.4
                    C13.6,4.6,13.9,4.3,13.9,4z M5.7,1.2h2.4l0.4,1.2H5.4L5.7,1.2z M11.5,14.3c0,0.3-0.3,0.6-0.6,0.6h-8c-0.3,0-0.6-0.3-0.6-0.6
                    L1.2,5.7h11.4L11.5,14.3z"/>
            </g>
            </svg>
         `,
};
